﻿(function () {
  var PRODUCT_SELECTOR = '.product__info-container';
  var MATCH_TEXT = /(avisem|avise|notifica|disponivel|disponível|available|notify|stock)/i;
  var BUTTON_SELECTOR = 'button, a, input[type="button"], input[type="submit"], [role="button"]';

  function buttonText(el) {
    if (!el) return '';
    return [
      el.textContent,
      el.value,
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.getAttribute('class'),
      el.getAttribute('id')
    ].filter(Boolean).join(' ');
  }

  function styleNotifyButton(el) {
    if (!el || el.dataset.msNotifyStyled === 'true') return;

    el.dataset.msNotifyStyled = 'true';
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('max-width', '44rem', 'important');
    el.style.setProperty('height', '3.4rem', 'important');
    el.style.setProperty('min-height', '3.4rem', 'important');
    el.style.setProperty('padding-top', '0.45rem', 'important');
    el.style.setProperty('padding-bottom', '0.45rem', 'important');
    el.style.setProperty('line-height', '1.1', 'important');
    el.style.setProperty('border-radius', '10px', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
  }

  function scanRoot(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(BUTTON_SELECTOR).forEach(function (el) {
      var text = buttonText(el);
      var appAncestor = el.closest && el.closest('.shopify-app-block, [class*="stoq" i], [id*="stoq" i], [class*="notify" i], [id*="notify" i], [class*="back-in-stock" i], [id*="back-in-stock" i]');

      if (MATCH_TEXT.test(text) || appAncestor) {
        styleNotifyButton(el);
      }
    });

    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        scanRoot(el.shadowRoot);
      }
    });
  }

  function scanProduct() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(scanRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanProduct);
  } else {
    scanProduct();
  }

  window.addEventListener('load', scanProduct);
  setTimeout(scanProduct, 500);
  setTimeout(scanProduct, 1500);
  setTimeout(scanProduct, 3000);

  new MutationObserver(scanProduct).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
